const RECEIVE_OMNI_STORE_LIST_DATA = 'src/omniStoreList/RECEIVE_OMNI_STORE_LIST_DATA' as const;
const START_FETCH = 'src/omniStoreList/START_FETCH' as const;
const END_FETCH = 'src/omniStoreList/EMD_FETCH' as const;

export default { RECEIVE_OMNI_STORE_LIST_DATA, START_FETCH, END_FETCH };
